import LoyaltyChooseDoubleRewardsBackground from './components/LoyaltyChooseDoubleRewardsBackground'
import LoyaltyChooseDoubleRewardsBannerDescription from './components/LoyaltyChooseDoubleRewardsBannerDescription'
import { SOCIETE_CHOOSE_DOUBLE_REWARDS_TAKEOVER_ID } from './loyaltyChooseDoubleRewardsTakeover.constants'

const loyaltyChooseDoubleRewardsTakeoverConfig: App.SiteTakeoverConfig = {
  id: SOCIETE_CHOOSE_DOUBLE_REWARDS_TAKEOVER_ID,
  // Don't add campaignTag to this takeover, otherwise it becomes a requirement. We want to be able to target offers without the campaign tag.
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  backgroundElement: LoyaltyChooseDoubleRewardsBackground,
  palette: 'default',
  siteWide: {
    banner: {
      description: <LoyaltyChooseDoubleRewardsBannerDescription />,
      align: 'center',
      tabletAlign: 'center',
      showOnHomePage: false,
    },
  },
}

export default loyaltyChooseDoubleRewardsTakeoverConfig
